
import { name, version } from '../package.json';
import { BROWSER } from 'esm-env';

let p_env: NodeJS.ProcessEnv = BROWSER ? {} : process.env;

export const USER_AGENT = `${name}/${version}`;

// Only for dev
export const ENABLE_GTM_IN_DEV = import.meta.env.ENABLE_GTM_IN_DEV;
export const IN_MEMORY_CACHE = import.meta.env.IN_MEMORY_CACHE; 

// Vite variables
/** Only in when running Astro with dev */
export const DEV = import.meta.env.DEV;
/** Both stage and live are prod because those are build */
export const PROD = import.meta.env.PROD;


// Env variables
/** Environment name required in production */
type Environment = 'stage' | 'live';
/** Environment group identifier */
type EnvironmentId = `g${number}`;
/** Environment domain zone */
type EnvironmentZone = `${Environment}.${EnvironmentId}` | Environment;

export const ENV_ZONE: EnvironmentZone | '' = (import.meta.env.ENV_NAME || p_env.ENV_NAME) as EnvironmentZone || '';
const [env_name, env_id]: [Environment, EnvironmentId] = ENV_ZONE.split('.') as [Environment, EnvironmentId];
export const ENV_ID: EnvironmentId = env_id || 'g1';
export const ENV_NAME: Environment | '' = env_name || '';
export const CACHE_SEGMENT = ENV_NAME || 'dev';

export const LIFERAY_CDN = import.meta.env.LIFERAY_CDN || p_env.LIFERAY_CDN || '';
export const LIFERAY_ORIGIN = import.meta.env.LIFERAY_ORIGIN || p_env.LIFERAY_ORIGIN || 'http://localhost:4040';

export const OAUTH2_LIFERAY_CLIENT_ID = import.meta.env.OAUTH2_LIFERAY_CLIENT_ID || p_env.OAUTH2_LIFERAY_CLIENT_ID || '';
export const OAUTH2_LIFERAY_CLIENT_SECRET = import.meta.env.OAUTH2_LIFERAY_CLIENT_SECRET || p_env.OAUTH2_LIFERAY_CLIENT_SECRET || '';

export const REDIS_URL = import.meta.env.REDIS_URL || p_env.REDIS_URL;

export const ENABLE_GTM = PROD || ENABLE_GTM_IN_DEV;


export const BUILD = __BUILD__;
export const BUILD_DATE = __BUILD_DATE__;
export const BUILD_STAMP = `Site22 · v${version} · ${BUILD} · ${BUILD_DATE} · ${CACHE_SEGMENT}`;

if (PROD && !BROWSER && !ENV_NAME) {
  console.error('Required ENV_NAME missing for production build!')
}

